var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('h1',{staticStyle:{"margin-bottom":"20px"}},[_vm._v("Impressum & Datenschutz")]),(_vm.imprint)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.imprint.content)}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }